import { TableViewStore, BaseListViewStore, BaasicDropdownStore, DateRangeQueryPickerStore } from "core/stores";
import { FacilityHistoryService, FacilityService } from "application/facility/services";
import { LookupService } from "common/services";
import _ from 'lodash';
import { toDate } from 'core/utils';
import { action } from "mobx";

class FacilityHistoryListViewStore extends BaseListViewStore {
	constructor(rootStore) {
        const facilityHistoryService = new FacilityHistoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
			autoInit: true,
			name: 'facility-history',
			routes: {},
			actions: () => {
				return {
					find: async params => {
						const initialFacilityId = this.rootStore.routerStore.routerState.params.id;
						
						const response = await facilityHistoryService.find(_.extend(params, {
							embed: 'Facility,HistoryEventType,CoreUser',
							facilityId: initialFacilityId ? initialFacilityId : params.facilityId
						}));

						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
										eventDate: item.eventDate && toDate(item.eventDate, true),
										facility: item.facility && item.facility.name,
										historyEventType: item.historyEventType && item.historyEventType.name,
										coreUser: item.coreUser && item.coreUser.fullName,
										description: item.description && item.description,
									}
								);
							}))
						});

						this.setTitle(params.facilityId);

						return responseData;
					}
				};
			},
		});

        this.facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);

        this.queryUtility.onResetFilter = ()=>{
            this.facilityStore.setValue(null);
			this.facilityStore.filterTerm = "";
			
            this.historyEventTypeStore.setValue(null);
            this.dateRangePickerStore.reset();
        }

        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
                const response = await this.facilityService.find({ isActive: true, searchQuery: term, rpp: 100 });
				
				return response.data.item;          
             }
		});

        this.historyEventTypeStore = new BaasicDropdownStore({
			filterable: false
		}, {
			fetchFunc: async() => {
				const response = await this.lookupService.getLookups('HistoryEventType');

				return response.historyEventTypes;
			}
		});

        this.dateRangePickerStore = new DateRangeQueryPickerStore();

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'eventDate',
						title: "FACILITY_HISTORY.LIST.COLUMNS.DATE_OF_CHANGE",
						width: 180
					},
					{
						key: 'facility',
						title: "FACILITY_HISTORY.LIST.COLUMNS.FACILITY",
						width: 300
					},
					{
						key: 'historyEventType',
						title: "FACILITY_HISTORY.LIST.COLUMNS.HISTORY_EVENT_TYPE",
						width: 180
					},
					{
						key: 'coreUser',
						title: "FACILITY_HISTORY.LIST.COLUMNS.CORE_USER",
						width: 230
					},
					{
						key: 'description',
						title: "FACILITY_HISTORY.LIST.COLUMNS.DESCRIPTION"
					}					
				],
			})
		);
    }

	@action.bound
	async setTitle(initialFacilityId) {
		const facilityId = initialFacilityId ? initialFacilityId : this.rootStore.routerStore.routerState.queryParams.facilityId;
		const facilityResponse = await this.facilityService.get(facilityId, null);
		const facilityName = facilityResponse.data && facilityResponse.data.name;

		this.rootStore.viewStore.setNavigationOptions({
			title: facilityName
		});
		
	}
}

export default FacilityHistoryListViewStore;